/* eslint-disable react/jsx-props-no-spreading */
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  COLOR_GREEN,
  COLOR_PRIMARY,
  COLOR_RED,
  COLOR_GREY,
} from 'constants/colors';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

export interface IProps {
  children: JSX.Element;
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading?: boolean;
  width?: number;
  color?: ButtonColor;
  size: ButtonSize;
} & IconProps;

const isDarkColor = (color: any) => {
  if (color === 'red') return true;
  if (color === 'grey') return true;
  if (color === 'blue') return true;
  return false;
};

const getButtonColor = (c: ButtonColor) => {
  if (c === 'grey') return COLOR_GREY;

  if (c === 'red') return COLOR_RED;

  if (c === 'green') return COLOR_GREEN;

  return COLOR_PRIMARY;
};

const sizeClassMap: Record<ButtonSize, string> = {
  xs: styles.size_xs,
  sm: styles.size_sm,
  md: styles.size_md,
  lg: styles.size_lg,
  full: styles.size_full,
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      color = 'blue',
      type = 'button',
      isLoading = false,
      startIcon,
      endIcon,
      size,
      width,
      children,
      className,
      style,
      ...rest
    },
    ref,
  ) => (
    <button
      ref={ref}
      // submit/reset supported via native button props from callers
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={clsx(
        styles.btn,
        sizeClassMap[size],
        isDarkColor(color) ? styles.textLight : styles.textDark,
        className,
      )}
      style={{
        backgroundColor: getButtonColor(color),
        width: width !== undefined ? `${width}px` : undefined,
        ...style,
      }}
      {...rest}
    >
      {isLoading && (
        <FontAwesomeIcon
          color="#fff"
          style={{
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 1,
            paddingBottom: 1,
          }}
          spin
          icon={faSyncAlt}
        />
      )}
      {!isLoading && startIcon}
      {!isLoading && children}
      {!isLoading && endIcon}
    </button>
  ),
);

export default Button;
